import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MainService {
  constructor(private http: HttpClient) {}

  getAll<responseDTO>(urlTarget: string): Observable<responseDTO[]> {
    return this.http.get<responseDTO[]>(`/api/${urlTarget}/GetAll`);
  }

  get<responseDTO>(urlTarget: string, id: number): Observable<responseDTO> {
    return this.http.get<responseDTO>(`/api/${urlTarget}/Get?id=` + id);
  }

  add<requestDTO, responseDTO>(
    urlTarget: string,
    request: requestDTO
  ): Observable<responseDTO> {
    return this.http.post<responseDTO>(`/api/${urlTarget}/Add`, request);
  }

  update<requestDTO, responseDTO>(
    urlTarget: string,
    request: requestDTO
  ): Observable<responseDTO> {
    return this.http.put<responseDTO>(`/api/${urlTarget}/Update`, request);
  }

  updateList<requestDTO, responseDTO>(
    urlTarget: string,
    clients: requestDTO[]
  ): Observable<responseDTO[]> {
    return this.http.put<responseDTO[]>(
      `/api/${urlTarget}/UpdateList`,
      clients
    );
  }

  delete(urlTarget: string, id: number): Observable<any> {
    return this.http.delete<any>(`/api/${urlTarget}/Delete?id=` + id);
  }
}
